import BaseTableReport from 'components/atoms/base-table/report/report';
import { useTranslation } from 'react-i18next';
import { useState, type FC } from 'react';
import { useCallHistoryManagementFilters } from 'infrastructure/hooks/callHistoryManagement/useFilters';

import { useColumns } from './useColumns';
import CallHistoryManagementModal from './managementModal';

import type {
  ICallHistory,
  ISplitCall,
} from 'infrastructure/hooks/callHistoryManagement/types';

interface Props {
  data?: ICallHistory[];
  count?: number;
  isLoading: boolean;
  updateItems: (data: {
    editingCall: ICallHistory;
    splits: ISplitCall[];
  }) => void;
}

const CallHistoryManagementTable: FC<Props> = ({
  data,
  count,
  isLoading,
  updateItems,
}) => {
  const { filter, updateFilter } = useCallHistoryManagementFilters();

  const { t } = useTranslation();
  const [editingItem, setEditingItem] = useState<ICallHistory | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(true);

  const setItem = (item: ICallHistory) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const columns = useColumns({
    setEditingItem: setItem,
  });

  return (
    <div>
      {editingItem && isModalOpen && (
        <CallHistoryManagementModal
          editingItem={editingItem}
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          onSubmit={(newItems) => {
            updateItems({ editingCall: editingItem, splits: newItems });
            setEditingItem(null);
            setIsModalOpen(false);
          }}
        />
      )}
      <BaseTableReport
        rowKey="id"
        isLoading={isLoading}
        columns={columns}
        headerTitle={t('labels.calls')}
        dataSource={data}
        pagination={{
          current: filter.page,
          pageSize: filter.items,
          total: count,
          onChange: (page) => {
            updateFilter({ page });
          },
        }}
        showCount
        anchor
      />
    </div>
  );
};

export default CallHistoryManagementTable;
